import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button, Collapse } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { roleStr } from '../../../common/common';
import LevelChoose from '../../Components/LevelChoose';
import Participate from '../../Components/Participate';
import ExpandMore from '@material-ui/icons/ExpandMore';
import InputList from '../../Components/InputList';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        marginTop: '20px',
        opacity: '0.13',
    },
    '& .line-b': {
        width: '100%',
        marginBottom: '20px',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
    '& .expandBtn': {
        cursor: 'pointer',
        height: '60px',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        borderBottom: '1px solid #F3F3F3',
    },
    '& .closeBtn': {
        cursor: 'pointer',
        height: '60px',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        borderBottom: '1px solid #F3F3F3',
    },
    '& .iconExpand': {
        margin: '0 10px',
        transform: "rotate(-180deg)",
        color: '#9B9B9B',
    },
    '& .iconClose': {
        margin: '0 10px',
        transform: "rotate(0deg)",
        color: '#9B9B9B',
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
class ReferralInfoView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contentData: [//type  1:text  2:date 3:note 4:auto 5:money
                {
                    title: "Basic Referral Info",
                    expanded: false,
                    content: [
                        {
                            name: "Date of Referral",
                            value: "2020-11-11",
                            type: 2,
                        }, {
                            name: "Type of case",
                            value: "Immigration-H1B",
                            type: 1,
                        }, {
                            name: "Referor",
                            value: "Bob Chen / ChenBob@mtlawllc.com / Business",
                            type: 4,
                        }, {
                            name: "Client name",
                            value: "Jessica Liu ",
                            type: 1,
                        }, {
                            name: "Client email",
                            value: "Jessica2011@yahoo.com",
                            type: 1,
                        }, {
                            name: "Client phone number",
                            value: "617-878-2222",
                            type: 1,
                        }, {
                            name: "Client Note",
                            value: "balabalabala…",
                            type: 3,
                        }, {
                            name: "Referee Pass Note",
                            value: "balabalabala…",
                            type: 3,
                        },
                    ]
                }, {
                    title: "Signing Records",
                    expanded: false,
                    content: [
                        {
                            name: "Date of Signing",
                            value: "2020-11-11",
                            type: 2,
                        }, {
                            name: "Case Number",
                            value: "Immigration-H1B",
                            type: 1,
                        }, {
                            name: "Type of Case",
                            value: "Immigration-H1B",
                            type: 1,
                        }, {
                            name: "Amount of Legal Fee (Optional in this Stage)",
                            value: 3800,
                            type: 5,
                        }
                    ]
                }, {
                    title: "Payment Records",
                    expanded: false,
                    content: [
                        {
                            name: "Date of Payment",
                            value: "2020/10/22",
                            type: 2,
                        }, {
                            name: "Date of Closing",
                            value: "2020/10/24",
                            type: 2,
                        }, {
                            name: "Type of Case",
                            value: "Immigration-H1B",
                            type: 1,
                        }, {
                            name: "Amount of Legal Fee",
                            value: 3800,
                            type: 5,
                        }, {
                            name: "Fee Payment",
                            value: 3800,
                            type: 5,
                        }, {
                            name: "Referee fee",
                            value: 5,
                            type: 6,
                        }
                    ]
                },
            ],

            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClickItem = this.handleClickItem.bind(this);
    }
    render() {
        const {
            contentData,
        } = this.state;
        const { caseNumber } = this.props;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        return (
            <Root>
                <div className="pageTitle">VIEW REFERRAL</div>
                <div className="line"></div>
                {contentData.map((itemObj, index) => (
                    <div key={index}>
                        <div className={itemObj.expanded ? "expandBtn h" : "closeBtn h"} onClick={e => this.handleClickItem(e, index)}>
                            <div>{itemObj.title}</div>
                            <ExpandMore className={itemObj.expanded ? "iconExpand" : "iconClose"} />
                        </div>
                        <Collapse className="extend" in={itemObj.expanded} timeout="auto" unmountOnExit>
                            <InputList
                                data={itemObj.content}
                            ></InputList>
                        </Collapse>
                    </div>
                ))}
                <div className="line-b"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        if (state === VIEW || state === EDIT) {
            this.setState(() => ({
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleClickItem(e, index) {
        const [...contentData] = this.state.contentData;
        const expanded = contentData[index].expanded
        contentData[index].expanded = !expanded;
        this.setState(() => ({
            contentData
        }));
    }
    handleCreate() {
        this.props.handleCreate();
    }
    handleCancel() {
        this.props.handleCancel();
    }
}

export default ReferralInfoView;